export default __webpack_public_path__ + "static/media/std_card2.95e42597.jpg";